import { render, staticRenderFns } from "./ListMembershipStale.vue?vue&type=template&id=3e119628&scoped=true"
import script from "./ListMembershipStale.vue?vue&type=script&lang=js"
export * from "./ListMembershipStale.vue?vue&type=script&lang=js"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "3e119628",
  null
  
)

export default component.exports